import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import ServiceReportsList from './ServiceReportsList'
import ServiceReportProfile from './ServiceReportProfile'
import ServiceReportPreview from './ServiceReportPreview'

export default function ServiceReports() {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/service_reports" component={ServiceReportsList} />
				<Route exact path="/service_reports/:id" component={ServiceReportProfile} />
				<Route exact path="/service_reports/preview/:id" component={ServiceReportPreview} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}